import _ from 'lodash'

export default {
  props: {
    value: {
      type: [Number, String, Date, Object, Boolean, Array],
      default: void 0
    },

    label: {
      type: String,
      default: void 0
    },

    isMandatory: {
      type: Boolean,
      default: false
    },

    question: {
      type: Object
    },

    dense: {
      type: Boolean,
      default: false
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    value (val) {
      this.val = this.isValueTypeValid(val) ? val : void 0
    },

    val (val) {
      this.debounceInputFn(val)
    }
  },

  data () {
    return {
      val: this.isValueTypeValid(this.value) ? this.value : void 0,
      outlined: true
    }
  },

  computed: {
    renderLabel () {
      return this.label
    },

    renderClasses () {

    }
  },

  methods: {
    // Override this to validate the type of the value or whatsoever.
    isValueTypeValid (value) {
      return true
    }
  },

  created () {
    this.debounceInputFn = _.debounce(val => {
      const valToCommit = typeof val === 'string' && val.trim().length === 0
        ? void 0
        : val
      this.$emit('input', valToCommit)
    }, 200)
  }
}
